import { TextInput, FormField, GroupedMultiSelect } from '@percent/lemonade'

import type { OpportunityFormLocationSectionProps } from './opportunity-form-location-section.types'

export function VirtualLocationFields({
  value,
  touched,
  errors,
  onChange,
  handleFormChange,
  onBlur,
  forceReadOnly,

  regionsGroupedOptions,

  videoConferencingLabel,
  videoConferencingPlaceholder,
  targetCountriesLabel,
  targetCountriesDescription,
  targetCountriesPlaceholder,
  targetCountriesSearchPlaceholder,
  targetCountriesSelectAllLabel,
  targetCountriesFooterTranslation,
}: Readonly<OpportunityFormLocationSectionProps>) {
  return (
    <>
      <FormField
        label={videoConferencingLabel}
        necessity="optional"
        status={
          touched.locationUrl && errors.locationUrl ? 'danger' : 'default'
        }
        statusMessage={
          typeof errors.locationUrl === 'string'
            ? errors.locationUrl
            : errors.locationUrl?.join(', ')
        }
        data-testid="locationUrlField"
        disabled={forceReadOnly}
      >
        <TextInput
          name="locationUrl"
          value={value.locationUrl}
          placeholder={videoConferencingPlaceholder}
          onBlur={onBlur}
          onChange={handleFormChange}
          borderRadiiSize="large"
          disabled={forceReadOnly}
        />
      </FormField>

      {!!regionsGroupedOptions && (
        <FormField
          label={targetCountriesLabel}
          necessity="optional"
          data-testid="targetCountriesField"
          description={targetCountriesDescription}
          disabled={forceReadOnly}
        >
          <GroupedMultiSelect
            data-testid="targetCountries"
            triggerPlaceholder={targetCountriesPlaceholder}
            searchPlaceholder={targetCountriesSearchPlaceholder}
            selectAllLabel={targetCountriesSelectAllLabel}
            data={regionsGroupedOptions}
            value={value.targetCountries}
            onChange={(newValue) => onChange('targetCountries', newValue)}
            getFooterTranslation={targetCountriesFooterTranslation}
            borderRadiiSize="large"
            disabled={forceReadOnly}
          />
        </FormField>
      )}
    </>
  )
}
